import axios from 'axios';
import { Config } from '../../config';

const emailUrl = `${Config.url.EMAIL_URL}/api/v1/Email`;

/**
 * Sends a templated email notification.
 * @to CSV of recipient email addresses.
 * @param templateName Name of the email template to use.
 * @param subject Email subject line.
 * @param values object to which the email template is to be bound.
 */
export const SendEmailByTemplate = (
    to: string,
    templateName: string,
    subject: string,
    values: object = {}
) => {
    const url = `${emailUrl}/SendByName/${templateName}`;
    const request = {
        tos: to.split(',').map((to) => to.trim()),
        subject: subject,
        values: { ...values }
    };

    axios.post(url, request).then(
        (e) => console.debug(e),
        (e) => console.error(e)
    );
};
